import React from "react"
import PropTypes from "prop-types"
import Input from "../../Input/Input"
import SelectField from "./wrappers/SelectField"
import CheckboxGroup from "../../CheckboxGroup"
import { filterOptions } from "./filterConfig"
import { setValue } from "./useReducer/actionCreators"
import styles from "./index.module.scss"

const TEXT_MAX_LENGTH = 64

// Two columns next to the listing. `kind` follows the field on the create form:
// checkboxes/selects for fields with options, text for free text fields.
const COLUMNS = [
  [
    {
      name: "organizationType",
      label: "Organization Type",
      kind: "checkboxes",
      collapseAfter: null,
    },
    { name: "levelType", label: "Business Stage", kind: "select" },
    { name: "companySize", label: "Company Size", kind: "select" },
    { name: "commitment", label: "Commitment Level", kind: "text" },
    { name: "experienceLevel", label: "Experience Level", kind: "select" },
    {
      name: "certifications",
      label: "Certification Requirements",
      kind: "text",
    },
  ],
  [
    {
      name: "businessFunctions",
      label: "Business Function / Expertise",
      kind: "checkboxes",
      collapseAfter: null,
    },
    {
      name: "fundingTypes",
      label: "Funding / Compensation Type",
      kind: "checkboxes",
      collapseAfter: null,
    },
    { name: "workEnvironment", label: "Work Model", kind: "select" },
    { name: "duration", label: "Duration", kind: "text" },
    {
      name: "geographicEligibility",
      label: "Geographic Eligibility",
      kind: "select",
    },
  ],
]

// Shown side by side under both columns; Source stays last.
const ROW = [
  { name: "status", label: "Opportunity Status", kind: "select" },
  { name: "source", label: "Source", kind: "select" },
]

const AdvancedFilters = ({ values, dispatch }) => {
  const options = filterOptions
  const set = (name) => (value) => dispatch(setValue(name, value))

  const renderField = ({ name, label, kind, collapseAfter }) => {
    if (kind === "checkboxes") {
      return (
        <CheckboxGroup
          id={`filter_${name}`}
          label={label}
          options={options[name]}
          values={values[name]}
          onChange={set(name)}
          collapseAfter={collapseAfter}
        />
      )
    }
    if (kind === "text") {
      return (
        <Input
          name={`filter_${name}`}
          type="text"
          label={label}
          placeholder="Any"
          value={values[name]}
          onChange={(e) =>
            set(name)(e.target.value.substring(0, TEXT_MAX_LENGTH))
          }
        />
      )
    }
    return (
      <SelectField
        id={`filter_${name}`}
        label={label}
        options={options[name]}
        value={values[name]}
        onChange={set(name)}
      />
    )
  }

  return (
    <div className={styles.advancedGrid}>
      {COLUMNS.map((fields, index) => (
        <div className={styles.column} key={index}>
          {fields.map((field) => (
            <div className={styles.item} key={field.name}>
              {renderField(field)}
            </div>
          ))}
        </div>
      ))}
      <div className={styles.row}>
        {ROW.map((field) => (
          <div className={styles.item} key={field.name}>
            {renderField(field)}
          </div>
        ))}
      </div>
    </div>
  )
}

AdvancedFilters.propTypes = {
  values: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
}

export default AdvancedFilters
